import * as React from "react";

const SvgReflux = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="361"
    height="23"
    version="1"
    viewBox="0 0 361 23"
    {...props}
  >
    <path fill={rackColor} d="M8.8 11.5.1 23h343.4l8.7-11.5L360.9 0H17.5z"></path>
    <path
   d="M8.8 11.5.1 23h343.4l8.7-11.5L360.9 0H17.5z"
      fill="none"
      stroke="black"
      strokeWidth="0.8"
    />
  </svg>
);

export default SvgReflux;
